import { useTranslation } from 'react-i18next'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import DateRangeFilterModal from '@/filter-modals/components/DateRangeFilterModal'
import TrenerFilterModal from '@/filter-modals/components/TrenerFilterModal'
import ProjectsTable from './components/ProjectsTable'
import useProjectsData from './hooks/useProjectsData'

export default function Projects() {
	const { t } = useTranslation()

	const {
		data: projectsData,
		loading,
		loadingMore,
		totalCount,
		hasMore,
		handleLoadMore,
		handleSort,
		handleSearchChange,
		handleApplyStartDateFilter,
		handleApplyTrenerFilter,
		handleDelete,
		handleDuplicate,
		sortColumn,
		sortDirection,
		searchQuery,
		fromDate,
		toDate,
		selectedTrainerId,
		hasStartDateFilter,
		hasTrenerFilter,
		isStartDateFilterOpen,
		setIsStartDateFilterOpen,
		isTrenerFilterOpen,
		setIsTrenerFilterOpen,
	} = useProjectsData()

	const buttons = [
		{
			type: 'add',
			to: '/centrumSzkolen/projekty/add',
			label: t('projects.list.actions.addNew'),
		},
	]

	return (
		<>
			<SearchActionsBar
				value={searchQuery}
				onChange={handleSearchChange}
				placeholder={t('projects.list.searchPlaceholder')}
				buttons={buttons}
			/>

			<ProjectsTable
				projectsData={projectsData}
				loading={loading}
				sortColumn={sortColumn}
				sortDirection={sortDirection}
				onSort={handleSort}
				hasStartDateFilter={hasStartDateFilter}
				onOpenStartDateFilter={() => setIsStartDateFilterOpen(true)}
				hasTrenerFilter={hasTrenerFilter}
				onOpenTrenerFilter={() => setIsTrenerFilterOpen(true)}
				onDelete={handleDelete}
				onDuplicate={handleDuplicate}
			/>

			<LoadMoreSection
				hasMore={hasMore}
				loadingMore={loadingMore}
				onLoadMore={handleLoadMore}
				dataLength={projectsData.length}
				totalCount={totalCount}
			/>

			<DateRangeFilterModal
				isOpen={isStartDateFilterOpen}
				onClose={() => setIsStartDateFilterOpen(false)}
				fromDate={fromDate}
				toDate={toDate}
				onApply={handleApplyStartDateFilter}
				title={t('projects.list.dateFilter.title', { defaultValue: 'Filtruj po dacie rozpoczęcia' })}
				description={t('projects.list.dateFilter.description', {
					defaultValue: 'Wybierz zakres dat, aby zawęzić listę projektów.',
				})}
				fromLabel={t('projects.list.dateFilter.fromDate', { defaultValue: 'Data od' })}
				toLabel={t('projects.list.dateFilter.toDate', { defaultValue: 'Data do' })}
				applyLabel={t('projects.list.filters.apply')}
				clearLabel={t('projects.list.filters.clear')}
				cancelLabel={t('projects.list.statusFilter.cancel', { defaultValue: 'Anuluj' })}
				invalidRangeMessage={t('projects.list.dateFilter.invalidRange', {
					defaultValue: 'Data początkowa nie może być późniejsza niż data końcowa.',
				})}
			/>

			<TrenerFilterModal
				isOpen={isTrenerFilterOpen}
				onClose={() => setIsTrenerFilterOpen(false)}
				selectedTrainerId={selectedTrainerId}
				onApply={handleApplyTrenerFilter}
				title={t('projects.list.filters.trenerTitle', { defaultValue: 'Filtruj po trenerze' })}
				description={t('projects.list.filters.trenerDescription', {
					defaultValue: 'Wybierz trenera, aby pokazać projekty, do których jest przypisany.',
				})}
				applyLabel={t('projects.list.filters.apply')}
				clearLabel={t('projects.list.filters.clear')}
			/>
		</>
	)
}
